import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit", "form"]
  static outlets = ["dialog"]

  connect() {
    this.formTarget.addEventListener("input", () => {
      this.toggleSubmit()
    })
    this.formTarget.addEventListener("change", () => {
      this.toggleSubmit()
    })
    this.formTarget.addEventListener("formStateChanged", () => {
      this.toggleSubmit()
    })
    this.toggleSubmit()
  }

  toggleSubmit() {
    let enable = false
    if (
      this.formTarget.checkValidity() === true &&
      this.requiredSelects() === true
    ) {
      this.submitTargets.forEach((target) => {
        target.disabled = false
        target.classList.remove("cursor-not-allowed")
      })
      enable = true
    } else {
      this.submitTargets.forEach((target) => {
        target.disabled = true
        target.classList.add("cursor-not-allowed")
      })
    }

    if (this.hasDialogOutlet) {
      this.dialogOutlet.toggleSubmit(enable)
    }
  }

  requiredSelects() {
    let valid_selects = true
    let required_selects = document.querySelectorAll(".required")
    required_selects.forEach((select) => {
      if (select.value === "") {
        valid_selects = false
      }
    })
    return valid_selects
  }

  disable() {
    this.submitTargets.forEach((target) => {
      target.disabled = true
      target.classList.add("cursor-not-allowed")
    })
    this.formTarget.submit()
  }

  submitOnEnter(event) {
    if (event.key !== "Enter" || event.shiftKey) return
    event.preventDefault()
    this.formTarget.requestSubmit()
  }
}
